<template>
  <div class="history">
    <button class="history__btn" @click="$router.go(-1)">
      <font-awesome-icon icon="chevron-left" />
    </button>
    <button class="history__btn" @click="$router.go(1)">
      <font-awesome-icon icon="chevron-right" />
    </button>
  </div>
</template>

<script>
export default {
  name: "history"
};
</script>

<style lang="sass" scoped>
.history

    &__btn
        margin: 0 5px
        outline: none
        transition: all .3s

        &:hover
            transform: scale(1.15)
</style>